import React from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
type TiltCardProps = {
  children: React.ReactNode;
  className?: string;
  max?: number;
};

/** Gentle 3D tilt that follows the pointer. Disabled for touch input and reduced-motion users. */
export function TiltCard({
  children,
  className = '',
  max = 6
}: TiltCardProps) {
  const reduce = useReducedMotion();
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const rotateX = useSpring(rx, {
    stiffness: 220,
    damping: 22
  });
  const rotateY = useSpring(ry, {
    stiffness: 220,
    damping: 22
  });
  const onMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (reduce || e.pointerType !== 'mouse') return;
    const rect = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    ry.set(px * max * 2);
    rx.set(-py * max * 2);
  };
  const onLeave = () => {
    rx.set(0);
    ry.set(0);
  };
  return <div className={className} style={{
    perspective: 1000
  }} data-id="element-551" data-mp="2brhx7597ii8k">
      <motion.div className="h-full" onPointerMove={onMove} onPointerLeave={onLeave} style={{
      rotateX,
      rotateY,
      transformStyle: 'preserve-3d'
    }} data-id="element-552" data-mp="2gp9wikc6l6ms">
        {children}
      </motion.div>
    </div>;
}